export type SelectId = number | '';

export const EMPTY_SELECT_VALUE: SelectId = '';

export type RelationValue =
  | number
  | string
  | {
      id?: number | string;
      name?: string;
      level?: number;
    }
  | null;

export function hasSelectedId(value: SelectId): value is number {
  return value !== EMPTY_SELECT_VALUE;
}

export function parseSelectValue(value: string): SelectId {
  if (value === EMPTY_SELECT_VALUE) return EMPTY_SELECT_VALUE;

  const parsed = Number(value);
  return Number.isNaN(parsed) ? EMPTY_SELECT_VALUE : parsed;
}

export function unpackItems<T>(response: unknown): T[] {
  if (Array.isArray(response)) return response;

  if (
    response &&
    typeof response === 'object' &&
    'items' in response &&
    Array.isArray(response.items)
  ) {
    return response.items;
  }

  return [];
}

export function normalizeNullableString(value?: string | null): string | null {
  const normalized = String(value ?? '').trim();
  return normalized ? normalized : null;
}

export function getRelationId(value?: RelationValue): SelectId {
  if (value == null) return EMPTY_SELECT_VALUE;

  if (typeof value === 'number') {
    return Number.isNaN(value) ? EMPTY_SELECT_VALUE : value;
  }

  if (typeof value === 'string') {
    return parseSelectValue(value.trim());
  }

  if (value.id == null) return EMPTY_SELECT_VALUE;

  return typeof value.id === 'number'
    ? Number.isNaN(value.id)
      ? EMPTY_SELECT_VALUE
      : value.id
    : parseSelectValue(value.id.trim());
}
